export enum PBadgeColor {
  INFO = 'info',
  POSITIVE = 'positive',
  WARNING = 'warning',
  NEGATIVE = 'negative',
}
